<div class="wrapper-page single-page-gift">
  <div class="wrapper-header-page">
    <div class="overlay-illustration-header"></div>
  </div>
  <div class="wrapper-content-page">
    <div class="wrapper-header-page-content">
      <div class="wrapper-back-btn">
        <div class="back-btn" [routerLink]="[PAGES_AND_PATHS.reservations.pagePath]">
          <i class="fa-solid fa-chevron-left"></i>
        </div>
        <span class="header-text">Rezervacija #{{reservationData?.id}}</span>
      </div>
    </div>
    <div class="wrapper-content-single-reservation">
      <h4 *ngIf="reservationData?.company_reservations?.length">Lista naručenih proizvoda</h4>
      <div *ngIf="reservationData?.company_reservations?.length" class="zc-table">
        <div class="zc-header-table">
          <div class="zc-header-row">
            <div class="zc-header-column">
              <span>Šifra</span>
            </div>
            <div class="zc-header-column">
              <span>Naziv</span>
            </div>
            <div class="zc-header-column">
              <span>Naziv biznisa</span>
            </div>
            <div class="zc-header-column">
              <span>Količina</span>
            </div>
            <div class="zc-header-column">
              <span>Kapara</span>
            </div>
            <div class="zc-header-column">
              <span>Cena</span>
            </div>
            <div class="zc-header-column">
              <span>Ukupno</span>
            </div>
            <div class="zc-header-column">
              <span>Promo kod</span>
            </div>
          </div>
        </div>
        <div class="zc-content-table">
          <div *ngFor="let business of reservationData?.company_reservations">
            <div *ngIf="business.business_category_id === 1" class="zc-content-row">
              <div class="zc-content-column">
                <span>{{ business.id }}</span>
              </div>
              <div class="zc-content-column">
                <span>Zakup termina</span>
              </div>
              <div class="zc-content-column">
                <span>{{ business.company.name }}</span>
              </div>
              <div class="zc-content-column">
                <span>/</span>
              </div>
              <div class="zc-content-column">
                <span>{{ business.down_payment | number: '1.2-2' }} RSD</span>
              </div>
              <div class="zc-content-column">
                <span>{{ business.price | number: '1.2-2' }} RSD</span>
              </div>
              <div class="zc-content-column">
                <span>{{ business.price | number: '1.2-2' }} RSD</span>
              </div>
              <div class="zc-content-column">
                <span>{{business.promo_code ? business.promo_code : '/'}} - {{ business.promo_value |
                  smartPercentage}}</span>
              </div>
            </div>
            <div *ngFor="let item of business.items" class="zc-content-row">
              <div class="zc-content-column">
                <span>{{ item.id }}</span>
              </div>
              <div class="zc-content-column">
                <span>{{ item.name }}</span>
              </div>
              <div class="zc-content-column">
                <span>{{ business.company.name }}</span>
              </div>
              <div class="zc-content-column">
                <span>{{item.pivot.quantity ? (item.pivot.quantity | number: '1.0-0') : 1}}</span>
              </div>
              <div class="zc-content-column">
                <span>{{ item.pivot.down_payment | number: '1.2-2' }} RSD</span>
              </div>
              <div class="zc-content-column">
                <span>{{ item.pivot.price | number: '1.2-2' }} RSD</span>
              </div>
              <div class="zc-content-column">
                <span>{{ ((item.pivot.quantity ? item.pivot.quantity : 1) * item.pivot.price) | number: '1.2-2'}}
                  RSD</span>
              </div>
              <div class="zc-content-column">
                <span>{{item.pivot.promo_code ? item.pivot.promo_code : '/'}} - {{item.pivot.promo_value |
                  smartPercentage}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="reservationData?.gifts?.length" class="zc-d-flex zc-align-items zc-justify-between ">
        <h4>Lista naručenih poklona</h4>
        <div>
          <button [disabled]="!checkedPresentIds?.length" (click)="isPresentsRefundModalOpen = true"
            class="zc-btn zc-btn--primary xs-mr-20">Refundacija</button>
        </div>
      </div>

      <div *ngIf="reservationData?.gifts?.length" class="zc-table">
        <div class="zc-header-table">
          <div class="zc-header-row">
            <div class="zc-header-column">
              <input type="checkbox" [checked]="isAllPagePresentChecked" (change)="onCheckAllPresentsChange()">
            </div>
            <div class="zc-header-column">
              <span>Šifra</span>
            </div>
            <div class="zc-header-column">
              <span>Naziv</span>
            </div>
            <div class="zc-header-column">
              <span>Količina</span>
            </div>
            <div class="zc-header-column">
              <span>Cena</span>
            </div>
            <div class="zc-header-column">
              <span>Ukupno</span>
            </div>
            <div class="zc-header-column">
              <span>Promo kod</span>
            </div>
          </div>
        </div>
        <div class="zc-content-table">
          <div *ngFor="let gift of reservationData?.gifts">
            <div class="zc-content-row">
              <div class="zc-content-column">
                <input type="checkbox" [value]="gift.id" [checked]="isPresentChecked(gift.id)"
                  (change)="onCheckPresent(gift.id)">
              </div>
              <div class="zc-content-column">
                <span>{{ gift.id }}</span>
              </div>
              <div class="zc-content-column">
                <span>{{ gift.name }}</span>
              </div>
              <div class="zc-content-column">
                <span>{{gift.pivot.quantity ? (gift.pivot.quantity | number: '1.0-0') : 1}}</span>
              </div>
              <div class="zc-content-column">
                <span>{{ gift.pivot.price | number: '1.2-2' }} RSD</span>
              </div>
              <div class="zc-content-column">
                <span>{{ ((gift.pivot.quantity ? gift.pivot.quantity : 1) * gift.pivot.price) | number: '1.2-2'}}
                  RSD</span>
              </div>
              <div class="zc-content-column">
                <span>{{gift.pivot.promo_code ? gift.pivot.promo_code : '/'}} - {{gift.pivot.promo_value |
                  smartPercentage}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <h4>Podaci o kupcu</h4>
      <div class="zc-table">
        <div class="zc-header-table">
          <div class="zc-header-row">
            <div class="zc-header-column">
              <span>Ime i prezime</span>
            </div>
            <div class="zc-header-column">
              <span>Grad</span>
            </div>
            <div class="zc-header-column">
              <span>Broj telefona</span>
            </div>
          </div>
        </div>
        <div class="zc-content-table">
          <div class="zc-content-row">
            <div class="zc-content-column">
              <span>{{ reservationData?.user.full_name }}</span>
            </div>
            <div class="zc-content-column">
              <span>{{ reservationData?.user.city?.name }}</span>
            </div>
            <div class="zc-content-column">
              <span>{{ reservationData?.user.phone }}</span>
            </div>
          </div>
        </div>
      </div>
      <h4>Podaci o uslogodavcima</h4>
      <div class="zc-table">
        <div class="zc-header-table">
          <div class="zc-header-row">
            <div class="zc-header-column">
              <span>Id</span>
            </div>
            <div class="zc-header-column">
              <span>Naziv</span>
            </div>
            <div class="zc-header-column">
              <span>Adresa</span>
            </div>
            <div class="zc-header-column">
              <span>Grad</span>
            </div>
            <div class="zc-header-column">
              <span>Broj telefona</span>
            </div>
            <div class="zc-header-column">
              <span>E-mail</span>
            </div>
            <div class="zc-header-column">
              <span>PIB</span>
            </div>
            <div class="zc-header-column">
              <span>Matični broj</span>
            </div>
          </div>
        </div>
        <div class="zc-content-table">
          <div *ngFor="let reservation of reservationData?.company_reservations" class="zc-content-row">
            <div class="zc-content-column">
              <span>{{ reservation.company.id }}</span>
            </div>
            <div class="zc-content-column">
              <span>{{ reservation.company.name }}</span>
            </div>
            <div class="zc-content-column">
              <span>{{ reservation.company.address }}</span>
            </div>
            <div class="zc-content-column">
              <span>{{ reservation.company.business_location?.name }}</span>
            </div>
            <div class="zc-content-column">
              <span>{{ reservation.company.mobile_number }}</span>
            </div>
            <div class="zc-content-column">
              <span>{{ reservation.company.user?.email }}</span>
            </div>
            <div class="zc-content-column">
              <span>{{ reservation.company.tax_identification_number }}</span>
            </div>
            <div class="zc-content-column">
              <span>{{ reservation.company.identification_number }}</span>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="reservationData?.invite_card?.wishlist_items?.length"
        class="zc-d-flex zc-align-items zc-justify-between ">
        <h4>Lista želja</h4>
        <div>
          <button (click)="exportWishlistPdf()" class="zc-btn zc-btn--primary xs-mr-20">Štampaj listu želja</button>
          <button (click)="exportWishlistExcel()" class="zc-btn zc-btn--primary">Skini listu želja</button>
        </div>
      </div>
      <div *ngIf="reservationData?.invite_card?.wishlist_items?.length" class="zc-table">
        <div class="zc-header-table">
          <div class="zc-header-row">
            <div class="zc-header-column">
              <span>Barcode</span>
            </div>
            <div class="zc-header-column">
              <span>Šifra</span>
            </div>
            <div class="zc-header-column">
              <span>Opis</span>
            </div>
            <div class="zc-header-column">
              <span>Ime artikla</span>
            </div>
            <div class="zc-header-column">
              <span>Nabavna cena</span>
            </div>
          </div>
        </div>
        <div class="zc-content-table">
          <div *ngFor="let wishlistItem of reservationData.invite_card.wishlist_items" class="zc-content-row">
            <div class="zc-content-column">
              <span>{{ wishlistItem.gift.barcode ? wishlistItem.gift.barcode : '/'}}</span>
            </div>
            <div class="zc-content-column">
              <span>{{ wishlistItem.gift_id }}</span>
            </div>
            <div class="zc-content-column">
              <span [innerHTML]="wishlistItem.gift?.description ? wishlistItem.gift?.description : '/'"></span>
            </div>
            <div class="zc-content-column">
              <span>{{ wishlistItem.gift.name ? wishlistItem.gift.name : '/'}}</span>
            </div>
            <div class="zc-content-column">
              <span>{{ wishlistItem.gift.wholesale_price ? wishlistItem.gift.wholesale_price : '/'}}</span>
            </div>
          </div>
        </div>
      </div>
      <h4>Podaci o porudzbini</h4>
      <div class="zc-table">
        <div class="zc-header-table">
          <div class="zc-header-row">
            <div class="zc-header-column">
              <span>Datum</span>
            </div>
            <div class="zc-header-column">
              <span>Ukupan iznos</span>
            </div>
            <div class="zc-header-column">
              <span>Placen iznos</span>
            </div>
            <div class="zc-header-column">
              <span>Za naplatu</span>
            </div>
            <div class="zc-header-column">
              <span>Samo depozit</span>
            </div>
            <div class="zc-header-column">
              <span>Grad</span>
            </div>
            <div class="zc-header-column">
              <span>Opstina</span>
            </div>
            <div class="zc-header-column">
              <span>Adresa</span>
            </div>
            <div class="zc-header-column">
              <span>Opis</span>
            </div>
          </div>
        </div>
        <div class="zc-content-table">
          <div class="zc-content-row">
            <div class="zc-content-column">
              <span>{{ reservationData?.date ?? ''}}</span>
            </div>
            <div class="zc-content-column">
              <span>{{ (reservationData?.total_amount ?? 0) | number: '1.2-2' }} RSD</span>
            </div>
            <div class="zc-content-column">
              <span>{{ (reservationData?.paid_amount ?? 0) | number: '1.2-2'}} RSD</span>
            </div>
            <div class="zc-content-column">
              <span>{{ ((reservationData?.total_amount ?? 0) - (reservationData?.paid_amount ?? 0)) | number: '1.2-2'}} RSD</span>
            </div>
            <div class="zc-content-column">
              <span>{{ reservationData?.is_deposit === 1 ? 'Da' : 'Ne' }}</span>
            </div>
            <div class="zc-content-column">
              <span>{{ reservationData?.city ?? ''}}</span>
            </div>
            <div class="zc-content-column">
              <span>{{ reservationData?.municipality ?? ''}}</span>
            </div>
            <div class="zc-content-column">
              <span>{{ reservationData?.delivery_address ?? ''}}</span>
            </div>
            <div class="zc-content-column">
              <span>{{ reservationData?.description ?? ''}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<gr-refund-presents-modal *ngIf="isPresentsRefundModalOpen"
  [refundData]="{gifts: checkedPresentIds, reservation_id: reservationData.id}"
  (closeModal)="isPresentsRefundModalOpen = false" (confirmModal)="onConfirmGiftsRefund()"></gr-refund-presents-modal>
